import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@workboard/wobo-ui';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader/root';
import { Header } from './Header';

const HeaderApp = hot((readOnlyePermission) => {
  if (hasLayout) return <></>;

  return (
    <ThemeProvider>
      <Header
          readOnlyePermission={readOnlyePermission.readOnlyePermission}
          readOnlyFeatureFlag={readOnlyePermission.readOnlyFeatureFlag}
      />
    </ThemeProvider>
  );
});

function initMyWorkHeader(readOnlyePermission) {
  createRoot(document.getElementById('my-work-header')).render(
    <HeaderApp
      readOnlyePermission={readOnlyePermission.readOnlyePermission}
      readOnlyFeatureFlag={readOnlyePermission.readOnlyFeatureFlag}
    />
  );
}

window.initMyWorkHeader = initMyWorkHeader;
